module.exports = __webpack_public_path__ + "img/not-authorized.bd09b662.svg";